/* DataInstanceEditor.js */

"use strict";
const GameEditor = require("@gluenetworks/game_editor");
const _ = require("lodash");
const Registrations = require("../../../RegistrationNamespaces");
require("./SlickImport.js");

class DataInstanceEditor extends GameEditor {
    constructor(logger, di, editorState, editorLayoutMgr, userSession, editorTabCmpnt, solutionsManager, editorLayout, ExplorerTemplate) {
        super(logger, di, editorState.editorState, editorLayoutMgr);
        this._logger = logger;
        this._tabCmpnt = editorTabCmpnt;
        this._editorTabState = editorState;
        this._activeOrgId = userSession.activeOrganization.id;
        this._editorLayout = editorLayout;
        this._explorerTemplate = ExplorerTemplate;
        this._template = undefined;

        let solutionDefinition = solutionsManager.getActiveSolution();
        let editorViews = _.get(solutionDefinition, "dataEditor.viewNamespaces", []);
        let editorActions = _.get(solutionDefinition, "dataEditor.actionNamespaces", []);
        let launchOptions = editorState.launchOptions;
        this.setNamespaceGlobs(editorViews.concat(editorActions), true);

        this.currentEntityRemoved = false;
        this.currentEntityDeleteInProgress = false;

        this._instanceEditorState = {};
        this._templateId = launchOptions.id;
        this._templateIds = launchOptions.ids;
        this.retardActions(true);
        this._isMultipleEdit = false; //this._osImageIds.length > 1;
        this._editorLayout.renderer._rootElem.classList.add("data-instance-editor");
        this.whenEditorIsReady = _.memoize(this.whenEditorIsReady);
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListenersOntemplate() {
        this._template.on("NamePropertyUpdated", (this._onNamePropertyUpdated = this._onNamePropertyUpdated.bind(this)));
        this._template.on("EntityDeletedFromSystem", (this._onTemplateRemoved = this._onTemplateRemoved.bind(this)));
        this._template.on("DirtyStateChanged", (this._onDirtyStateChanged = this._onDirtyStateChanged.bind(this)));
    }

    _unregisterListenersOntemplate() {
        this._template.removeListener("NamePropertyUpdated", this._onNamePropertyUpdated);
        this._template.removeListener("EntityDeletedFromSystem", this._onTemplateRemoved);
        this._template.removeListener("DirtyStateChanged", this._onDirtyStateChanged);
    }

    _onDirtyStateChanged(newVal) {
        this._tabCmpnt.setDirty(newVal);
    }

    getTabCmpnt() {
        return this._tabCmpnt;
    }

    get activeOrgId() {
        return this._activeOrgId;
    }

    get editorTabStateId() {
        return this._editorTabState.id;
    }

    get template() {
        return this._template;
    }

    whenEditorIsReady() {
        if (this._template) {
            return Promise.resolve(this._template);
        }
        return this._explorerTemplate.retrieveAscendExplorerTemplate(this.activeOrgId, this._templateId).then((template) => {
            this._template = template;
            this._registerListenersOntemplate();
            return Promise.resolve(template);
        });
    }

    launchNewTab(template) {
        let launchOpts = {
            id: template.id,
            title: _.get(template, "name", "")
        };
        const id = launchOpts.id;
        launchOpts = _.assign({}, launchOpts, {
            id,
            ids: [id]
        });
        return this._editorLayout.launchEditor({ fqn: Registrations.DEIE_VIEW_DETAILS }, Registrations.DATA_INSTANCE_EDITOR, launchOpts);
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    updateTab(name) {
        this._tabCmpnt.setTitle(name);
    }

    updateTabIcon(iconName) {
        this._tabCmpnt.setEditorIconName(iconName);
    }

    _onNamePropertyUpdated() {
        this.updateTab(this._template.pristineProperties.name);
    }

    _onTemplateRemoved() {
        this.currentEntityRemoved = true;
        if (!this.currentEntityDeleteInProgress) {
            this.currentEntityRemoved = false;
            this.closeEditor(this.editorTabStateId, true);
        }
    }

    closeEditor(id, force) {
        id = id || this._editorTabState.id;
        return super.closeEditor(id, force);
    }

    shutdown() {
        let logger = this._logger;
        this.whenEditorIsReady.cache.clear();

        return Promise.all([_.invoke(this._template, "shutdown")])
            .then(() => super.shutdown())
            .then(() => {
                this._logger = undefined;
                this._editorTabState = undefined;

                this._tabCmpnt = undefined;
                this._template = undefined;
                this._activeOrgId = undefined;
                this._templateId = undefined;
                this.currentEntityRemoved = undefined;
                this.currentEntityDeleteInProgress = undefined;
            })
            .catch((err) => {
                logger.warn({ error: err }, "FileInstanceEditor.shutdown() error");
            });
    }

    setInstanceEditorStateProperty(name, val) {
        _.set(this._instanceEditorState, name, val);
    }

    getInstanceEditorStateProperty(name) {
        return _.get(this._instanceEditorState, name);
    }

    setViewActionText(buttonValue, buttonText) {
        let buttonControl = _.get(
            this._viewContainerElem.nextElementSibling.lastElementChild.querySelectorAll("button-control[value='" + buttonValue + "']"),
            0
        );

        if (buttonControl) {
            buttonControl.innerHTML = buttonText;
        }
    }

    /*******************************************/
    /* END PUBLIC COMPONENT MODEL METHODS      */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE API METHODS                 */
    /*******************************************/
}

module.exports = DataInstanceEditor;

DataInstanceEditor.$inject = [
    "$teve.logger",
    "$teve.di",
    "editorLayout.editorState",
    "editorLayout.editorLayoutMgr",
    "$teve.userSession",
    "editorLayout.editor.tabComponent",
    "$teve.solutionsManager",
    "EditorLayout.EditorLayout",
    "$teve.entities.ExplorerTemplate"
];

//Optional convenient way to set a tab icon.
DataInstanceEditor.$editorIcon = "dataexplorer.solution";
DataInstanceEditor.$editorIconType = "base-icon-gl";
